/* Hook encargado de crear o modificar  la reserva

Autor: Benjamín León
Fecha: 2024-10-01
*/
import { useState } from 'react'

import { normalizeDate } from '../utils/utils.ts'
import SettlementDto from '../interfaces/SettlementDto.ts'
import { customPost } from '../utils/customFetch.ts'

import { makeUrlSettlementCrea } from './connectionData.tsx'

const useSettlementCrea = () => {
  const [errorSettlementCrea, setErrorSettlementCrea] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)

  const settlementCrea = async (settlement: SettlementDto) => {
    setLoading(true)

    try {
      const id = await updateDatabase(settlement)
      setErrorSettlementCrea(null)

      return id
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorSettlementCrea(err)
      } else {
        setErrorSettlementCrea(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoading(false)
    }
  }
  const updateDatabase = async (settlement: SettlementDto): Promise<string> => {
    const apiUrl = makeUrlSettlementCrea()
    // Tenemos que cambiarle las fechas a los costos

    ;(settlement.expenses ?? []).forEach((element) => {
      element.date = normalizeDate(element.date)
    })

    settlement.date = normalizeDate(settlement.date)
    const res = await customPost<{ _id: string }>(apiUrl, settlement)

    return res._id
  }

  // Exponemos estas variables al exterior
  return { errorSettlementCrea, loading, settlementCrea }
}
export default useSettlementCrea
